(function () {
  var DESKTOP = window.matchMedia('(min-width: 750px)');

  /** @param {HTMLElement} scroller */
  function bind(scroller) {
    if (scroller.dataset.pdpSync) return;
    scroller.dataset.pdpSync = '1';

    var slideshow = scroller.closest('slideshow-component');
    if (!slideshow) return;

    var ticking = false;
    var lastIndex = -1;

    function slides() {
      return Array.prototype.slice.call(scroller.querySelectorAll(':scope > slideshow-slide'));
    }

    function thumbnails() {
      return Array.prototype.slice.call(slideshow.querySelectorAll('[ref="thumbnails[]"]'));
    }

    function currentIndex() {
      var list = slides();
      var box = scroller.getBoundingClientRect();
      var mid = box.top + box.height / 2;
      var best = 0;
      var bestDistance = Infinity;
      list.forEach(function (slide, i) {
        var rect = slide.getBoundingClientRect();
        if (!rect.height) return;
        var distance = Math.abs(rect.top + rect.height / 2 - mid);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }

    /** @param {HTMLElement} thumb */
    function revealThumb(thumb) {
      var container = thumb.closest('[ref="thumbnailsContainer"]');
      if (!container) return;
      var c = container.getBoundingClientRect();
      var t = thumb.getBoundingClientRect();
      if (t.top >= c.top && t.bottom <= c.bottom) return;
      var target = container.scrollTop + (t.top - c.top) - (c.height - t.height) / 2;
      container.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
    }

    function update() {
      ticking = false;
      if (!DESKTOP.matches) return;

      var index = currentIndex();
      if (index === lastIndex) return;
      lastIndex = index;

      var thumbs = thumbnails();
      thumbs.forEach(function (thumb, i) {
        thumb.setAttribute('aria-selected', String(i === index));
      });
      if (thumbs[index]) revealThumb(thumbs[index]);
    }

    scroller.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );

    update();
  }

  /**
   * Sizes the main image box to the photo ratio and shifts it so its centre
   * matches the centre of the product grid (i.e. the page), without overlapping
   * the details column.
   */
  function centerMain() {
    document.querySelectorAll('.product-information__media media-gallery').forEach(function (gallery) {
      var container = gallery.querySelector('slideshow-component > slideshow-container');
      var grid = gallery.closest('.product-information__grid');
      if (!container || !grid) return;

      if (!DESKTOP.matches) {
        container.style.removeProperty('--pdp-main-width');
        container.style.removeProperty('--pdp-main-offset');
        return;
      }

      var media = container.querySelector('.product-media');
      var ratio = media ? parseFloat(getComputedStyle(media).getPropertyValue('--ratio')) : NaN;
      if (!ratio || !isFinite(ratio)) ratio = 0.75;

      container.style.setProperty('--pdp-main-offset', '0px');
      container.style.setProperty('--pdp-main-width', '100%');

      var area = container.getBoundingClientRect();
      var available = area.width;
      var width = Math.min(available, area.height * ratio);

      var gridBox = grid.getBoundingClientRect();
      var desiredLeft = gridBox.left + gridBox.width / 2 - width / 2;
      var offset = Math.max(0, Math.min(desiredLeft - area.left, available - width));

      container.style.setProperty('--pdp-main-width', width + 'px');
      container.style.setProperty('--pdp-main-offset', offset + 'px');
    });
  }

  var resizeScheduled = false;
  function scheduleCenter() {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(function () {
      resizeScheduled = false;
      centerMain();
    });
  }

  window.addEventListener('resize', scheduleCenter);
  window.addEventListener('load', scheduleCenter);

  function scan() {
    document
      .querySelectorAll('.product-information__media media-gallery slideshow-slides[ref="scroller"]')
      .forEach(bind);
    scheduleCenter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  /* Variant changes re-render the gallery */
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      scan();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
